/* eslint-disable no-undef */
// import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './utils/sls-track'
import reportWebVitals from './reportWebVitals';
import AppRoute from './router'

ReactDOM.render(
  // <React.StrictMode>
    <AppRoute />,
  // </React.StrictMode>,
  document.getElementById('root')
);

// ga('create', process.env.REACT_APP_GA_TRACKID, 'auto');


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
